export default __webpack_public_path__ + "static/media/pesto_margarita_proxy.6ac98182.png";